import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useSummaryUnitCostInputTooltipAlert = (
  profitabilityMode,
  hasFixedPrice,
) => {
  const { t } = useTranslation();
  
  const messageTitle = useMemo(() => {
    if(profitabilityMode && hasFixedPrice)
      return t("views.editor.profitability_fixed_alert.title")
  }, [ profitabilityMode, hasFixedPrice ]);
  
  const messageContent = useMemo(() => {
    if(profitabilityMode && hasFixedPrice)
      return t("views.editor.profitability_fixed_alert.content")
  }, [ profitabilityMode, hasFixedPrice ]);
  
  return {
    messageTitle,
    messageContent,
  }
}